import handleModal from '../modal/handle-modal';

const handleOrderModal = () => {
  handleModal($('[href*="modal"]'))
}

handleOrderModal();
